import { FunctionalComponent, h } from '@stencil/core';
import state from '@ugc-store';
import { PdpFeatureImpactType } from './enum';

const ViewDesktop: FunctionalComponent<{ productId: number }> = ({ productId }) => {
  const {
    reviewStaticLanguage: { IDS_AUTH_CUSTOMER_REVIEWS = '' },
    isReviewLoading,
    ids,
    isReviewListLoaded,
    isEnableTagsV2,
    isEnableSummary,
    featureImpactType,
  } = state;
  const isHaveReview = isReviewListLoaded && !!ids.length;

  const isEnabledTagsOrSummary = isEnableTagsV2 || isEnableSummary;

  const isHideAuthenticBanner = featureImpactType === PdpFeatureImpactType.HideAuthenticBanner;

  const isHideWriteReviewBanner = featureImpactType === PdpFeatureImpactType.HideWriteReviewBanner;

  const isHideAiGenReviewTagsAndBanner = featureImpactType === PdpFeatureImpactType.HideAiGenReviewTagsAndBanner;

  const isHideTopReviews = featureImpactType === PdpFeatureImpactType.HideTopReviews;

  return (
    <div class="ugc-global-css-wrap">
      {/* "ugc-pdp-review-section" is used for performace script ,could not change */}
      <div class="ugc-pdp-review-desktop-box ugc-pdp-review-section ugc-component-wrap">
        {isReviewLoading && <ugc-loading />}
        <ugc-title size={24} text={IDS_AUTH_CUSTOMER_REVIEWS} class="mb-24" />
        <div class="ugc-review-content">
          <div class={`ugc-review-summary ${!isHaveReview && 'none'}`}>
            <div class="ugc-review-rating mb-16">
              {!isHideAuthenticBanner && <ugc-authentic-banner />}
              <ugc-review-ratings productId={productId} />
              <ugc-review-progress-bar />
            </div>

            <div class="ugc-review-banner">
              {!isHideWriteReviewBanner && (
                <div>
                  <ugc-review-banner />
                  <ugc-write-review-button />
                </div>
              )}

              {!!window.productCardHtmlInReview ? (
                <div class="ugc-review-sponsored-product" innerHTML={window.productCardHtmlInReview}></div>
              ) : (
                <div class="ugc-review-sponsored-product"></div>
              )}
            </div>
          </div>
          <div class="ugc-review-main">
            {isEnabledTagsOrSummary && !isHideAiGenReviewTagsAndBanner ? (
              <ugc-review-tagsv2 productId={productId} />
            ) : null}
            {!isHideTopReviews && <ugc-review-top-review />}
            <ugc-review-dt-all-images productId={productId} />
            <ugc-review-global-title />
            <ugc-page-summary productId={productId} />
            <ugc-review-pending productId={productId} />
            <ugc-review-list productId={productId} />
            <ugc-review-no-data />
          </div>
        </div>
        <ugc-review-scroll-ga />
        <ugc-review-dt-all-images-modal class="ugc-review-dt-all-images-modal" />
        <ugc-review-dt-all-images-detail-modal class="ugc-review-dt-all-images-detail-modal" />
        <ugc-review-learn-more-modal />
        <ugc-review-dt-image-modal class="ugc-review-dt-image-modal" />
        <ugc-review-top-review-modal />
        <ugc-review-rewarded-modal />
        <ugc-review-medal-modal />

        {/* desktop qna and review common component  */}
        <ugc-report-abuse-modal />
        <ugc-action-permission action={['review', 'question', 'answer', 'vote']} productId={productId} />
        <ugc-alert />
        <ugc-perimeterx-modal />
        <ugc-product productId={productId} />
      </div>
    </div>
  );
};

export default ViewDesktop;
